module.exports = __webpack_public_path__ + "img/alert.10a5fa88.png";